export default {
  app: {
    name: "EpicMas Back Office",
    full: "EpicMas Back Office",
    minimized: "EPBO"
  },
  welcome: "Welcome back, {user}!",
  login: "Sign In to your account",
  relogin: "Please re-login to your account again.",
  expired: "Session Expired!",
  denied: "Permission Denied!",
  success: "You have successfully completed!",
  search_by_id_name: "Search by ID or Name",
  search_by_id: "Search by ID",
  change_user_status_confirm: "Are you sure you want to change the Account Status?",
  delete_confirm: "Are you sure you want to delete \"{name}\"",
  successful_change_password: "You have successfully change password.",
  change_disable_confirm: "Are you sure you want to change \"{name}\" to disable?",
  select_option: "Select your option",
  no_data_available: "No Data Available",
  no_rating_available: "No Rating Available",
  successful_update_security: "You have successfully update security.",
  successful_disable_security: "You have successfully disable security.",
  update_security_confirm: "Are you sure you want to update security?",
  disable_security_confirm: "Are you sure you want to disable security?",
  change_operator_status_confirm: "Are you sure you want to change operator \"{name}\" status?",
  change_member_status_confirm: "Are you sure you want to change member \"{name}\" status?",
  approve_ticket_confirm: "Are you sure you want to approve the ticket?",
  reject_ticket_confirm: "Are you sure you want to reject the ticket?",
  change_self_operate_confirm: "Are you sure you want to change \"{name}\" operation mode?",
  change_bank_account_status_confirm: "Are you sure want to change \"{name}\" account status?",
  change_ibank_account_status_confirm: "Are you sure want to change \"{name}\" account status?",
  change_promo_status_confirm: "Are you sure want to change \"{name}\" promotion status?",
  change_promo_signup_status_confirm: "Are you sure want to change \"{name}\" promotion signup status?",
  knock_off_promo_confirm: "Are you sure you want to knock off \"{name}\" promotion?",
  successful_promo_package_download: "You have successfully download promotion package.",
  successful_update_account_setup: "You have successfully update account setup.",
  unblock_member_confirm: "Are you sure you want to unblock member \"{name}\"?",
  unblock_operator_confirm: "Are you sure you want to unblock operator \"{name}\"?",
  block_sub_account_confirm: "Are you sure you want to block sub account \"{name}\"?",
  unblock_sub_account_confirm: "Are you sure you want to unblock sub account \"{name}\"?",
  successful_create_secondary_account: "You have successfully create secondary account.",
  update_account_password_confirm: "Are you sure you want to update account password?",
  successful_update_account_password: "You have successfully update account password.",
  update_account_password_cancel: "Are you sure you want to cancel update account password?",
  change_affiliate_status_confirm: "Are you sure you want to change affiliate \"{name}\" status?",
  approve_affiliate_confirm: "Are you sure you want to approve \"{name}\" as affiliate?",
  unblock_affiliate_confirm: "Are you sure you want to unblock affiliate \"{name}\"?",
  change_coupon_status_confirm: "Are you sure want to change \"{name}\" coupon status?",
  submit_acknowledgement_confirm: "Are you sure want to submit acknowledgement?",
  change_bank_group_default_confirm: "Are you sure want to set \"{name}\" as default bank group?",
  change_withdrawal_limit_default_confirm: "Are you sure want to set \"{name}\" as default withdrawal limit?",
  change_promotion_group_default_confirm: "Are you sure want to set \"{name}\" as default promotion group?",
  change_referral_status_confirm: "Are you sure you want to change \"{name}\" referral status?",
  change_withdrawal_limit_confirm: "Are you sure you want to change \"{name}\" withdrawal limit?",
  change_promotion_group_confirm: "Are you sure you want to change \"{name}\" promotion group?",
  change_bank_group_confirm: "Are you sure you want to change \"{name}\" bank group?",
  change_member_bet_limit_confirm: "Are you sure you want to change \"{name}\" \"{provider}\" bet limit?",
  assign_free_credit_confirm: "Are you sure want to assign free credit to \"{name}\"?",
  update_survey_status_confirm: "Are you sure you want to update survey status?",
  successful_clear_outstanding: "You have successfully clear {amt} outstanding amount.",
  clear_outstanding_confirm: "Are you sure want to clear \"{name}\" outstanding?",
  trace_outstanding_confirm: "Are you sure want to trace \"{name}\" outstanding?",
  clear_maintenance_time_confirm: "Are you sure want to clear \"{name}\" maintenance time?",
  change_promotion_group_seq_confirm: "Are you sure want to change \"{promotion}\" sequence under \"{group}\"?",
  cancel_unfinish_round_confirm: "Are you sure want to cancel unfinish round \"{round}\"?",
  no_member_found: "No Member Found",
  move_banner_up_confirm: "Are you sure want to move banner \"{name}\" up?",
  move_banner_down_confirm: "Are you sure want to move banner \"{name}\" down?",
  delete_banner_confirm: "Are you sure want to delete banner \"{name}\"?",
  change_banner_status_confirm: "Are you sure you want to change banner \"{name}\" status?",
  delete_page_confirm: "Are you sure want to delete page \"{name}\"?",
  change_page_status_confirm: "Are you sure you want to change page \"{name}\" status?",

  move_news_up_confirm: "Are you sure want to move news \"{name}\" up?",
  move_news_down_confirm: "Are you sure want to move news \"{name}\" down?",
  delete_news_confirm: "Are you sure want to delete news \"{name}\"?",
  change_news_status_confirm: "Are you sure you want to change news \"{name}\" status?",

  add_domain_remark: "Support to setup seo for multiple domains. eg.",
};
